import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { BookPreview } from './components/BookPreview';
import { ProblemSection } from './components/ProblemSection';
import { BodySignals } from './components/BodySignals';
import { FailedSolutions } from './components/FailedSolutions';
import { RealCost } from './components/RealCost';
import { SolutionMap } from './components/SolutionMap';
import { EmotionGuide } from './components/EmotionGuide';
import { Transformation } from './components/Transformation';
import { AuthorStory } from './components/AuthorStory';
import { WhatIncludes } from './components/WhatIncludes';
import { AuthorQuote } from './components/AuthorQuote';
import { SelfCare } from './components/SelfCare';
import { PriceBlock } from './components/PriceBlock';
import { TransitionBlock } from './components/TransitionBlock';
import { BonusPresentation } from './components/BonusPresentation';
import { BonusValue } from './components/BonusValue';
import { StatBlock } from './components/StatBlock';
import { MicroProof } from './components/MicroProof';
import { UrgencyBlock } from './components/UrgencyBlock';
import { UpdatedFinalCTA } from './components/UpdatedFinalCTA';
import { Testimonial } from './components/Testimonial';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Set page title and Open Graph meta tags
    document.title = 'Cuando Todo Recae Sobre Ti — Guía para Cuidadores de Padres';
    const setMeta = (property: string, content: string) => {
      let el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    const setMetaName = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('og:title', 'Cuando Todo Recae Sobre Ti — Guía para Cuidadores de Padres');
    setMeta('og:description', 'El libro + 5 bonos para cuidadores que cargan solos. Límites, reparto y descanso real. Solo $17.00.');
    setMeta('og:type', 'website');
    setMeta('og:url', 'https://cuidador-de-padres.tucambiohoy.online/14');
    setMeta('og:image', 'https://cdn.magicpatterns.com/uploads/x4ZFy1Tvh8UQZ75dG1Cae7/BONO__1.png');
    setMetaName('description', 'El libro + 5 bonos para cuidadores que cargan solos. Límites, reparto y descanso real. Solo $17.00.');
    // Meta Pixel initialization
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', '1244561417649286');
    window.fbq('track', 'PageView');
  }, []);
  return <main className="min-h-screen bg-cream text-navy font-sans selection:bg-terracotta/30" data-id="element-0">
      {/* Banner de urgencia */}
      <div className="bg-terracotta text-white text-center py-3 px-4 font-bold text-sm md:text-base tracking-widest uppercase animate-pulse" data-id="element-1">
        🔥 OFERTA POR TIEMPO LIMITADO 🔥
      </div>
      <Hero data-id="element-2" />
      <PainSection data-id="element-3" />
      <BookPreview data-id="element-4" />
      <ProblemSection data-id="element-5" />
      <BodySignals data-id="element-6" />
      <FailedSolutions data-id="element-7" />
      <RealCost data-id="element-8" />
      <SolutionMap data-id="element-9" />
      <EmotionGuide data-id="element-10" />
      <Transformation data-id="element-11" />
      <AuthorStory data-id="element-12" />
      <WhatIncludes data-id="element-13" />
      <AuthorQuote data-id="element-14" />
      <SelfCare data-id="element-15" />
      <PriceBlock data-id="element-16" />
      <TransitionBlock data-id="element-17" />
      <BonusPresentation data-id="element-18" />
      <BonusValue data-id="element-19" />
      <StatBlock data-id="element-20" />
      <UpdatedFinalCTA data-id="element-21" />
      <Testimonial data-id="element-22" />
      <FAQ data-id="element-23" />
      <Footer data-id="element-24" />
      <RecentPurchaseToast data-id="element-25" />
    </main>;
}